<div class="w-[450px]">
  <div class="grid">
    <div class="flex flex-col justify-between">
      <div>
        Upload your open PO Report using the Auxilius template below. This will replace any PO
        report previously uploaded.
      </div>

      <aux-download-template-button
        label="Download template"
        class="mb-4"
        classList="pl-0"
        fileName="auxilius-template-PO_REPORT"
        [templateType]="templateType"
      />

      <div class="mb-4">
        <div class="mb-1">Upload PO Report</div>

        <aux-file-manager
          #manager
          class="h-48"
          [fetchFilesOnInit]="false"
          [pathFn]="pathFn"
          [eager]="false"
          [metadata]="metadata"
          [showSuccessOnUpload]="true"
          [accept]="'.csv'"
          [extensions]="['text/csv']"
        />

        @if (fileManager?.fileQuery?.selectAll() | async; as files) {
          @if (files.length) {
            @for (file of files; track file; let last = $last) {
              <ng-container class="border-b">
                <div
                  class="flex items-center justify-between py-2"
                  [ngClass]="{ 'border-b': !last }"
                >
                  <div class="items-start break-all text-xs">
                    {{ file.fileName }}
                  </div>

                  <button
                    class="btn h-6 w-6 rounded-full border-0 p-0 shadow-none"
                    type="button"
                    (click)="removeFile(file)"
                  >
                    <aux-icon name="Trash" class="text-aux-error" />
                  </button>
                </div>
              </ng-container>
            }
          }
        }
      </div>

      <div class="flex flex-col justify-between">
        <aux-input label="Document Short Name" [formControl]="documentShortName" />
      </div>
    </div>
  </div>
</div>
